import { __awaiter, __decorate, __metadata } from 'tslib';
import * as ClipboardWeb from 'clipboard/dist/clipboard.min.js';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { ToastController, IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { QRCodeModule } from 'angularx-qrcode';
import { ReactiveFormsModule } from '@angular/forms';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCUserAccountInfoComponent = class UiCUserAccountInfoComponent {
    constructor(toastCtrl, clipboardApp) {
        this.toastCtrl = toastCtrl;
        this.clipboardApp = clipboardApp;
        this.isChangeAccount = false;
        this.changeAccount = new EventEmitter();
        this.changeLanguage = new EventEmitter();
        this.copyText = new EventEmitter();
        this.clipboardWeb = new ClipboardWeb('#cpyBtn');
        this.clipboardWeb.on('success', () => {
            this.toastCopy();
        });
    }
    copyAccountData() {
        this.copyText.emit();
        //this.clipboardApp.copy(this.qrCodeValue);
    }
    ngOnInit() {
        this.qrCodeValue = `DADOS DA CONTA
    Nome: ${this.userProfile.fullName}
    CPF/CNPJ: ${this.userProfile.document}
    Banco: ${this.userProfile.codeBank} - ${this.userProfile.nameBank}
    Agência: ${this.userProfile.agencyBank}
    Conta: ${this.setDigitAccountBank(this.userProfile.numberAccountBank)}

    Obs: Selecione a opção CONTA DE PAGAMENTO no seu banco para transferir para esta conta.
    
    `;
    }
    toastCopy() {
        return __awaiter(this, void 0, void 0, function* () {
            const toast = yield this.toastCtrl.create({
                message: 'Operação realizada com sucesso! Já pode compartilhar seus dados.',
                duration: 20000,
                position: 'top',
                buttons: [
                    {
                        text: 'Fechar',
                        role: 'cancel',
                        handler: () => { },
                    },
                ],
            });
            toast.present();
        });
    }
    setDigitAccountBank(digit) {
        if (!!digit) {
            let account = '';
            let count = digit.length;
            let penultimate = count - 2;
            for (let i = 0; i < count; i++) {
                account += digit[i];
                if (i == penultimate) {
                    account += '-';
                }
            }
            return account;
        }
        else {
            return '--';
        }
    }
    changeAccountEvent() {
        this.changeAccount.emit();
    }
    verifyTypeDocument(document) {
        if (!!document && document.length > 14) {
            return 'CASH_IN.DASHBOARD_MENU.DOCUMENT_CNPJ';
        }
        else {
            return 'CASH_IN.DASHBOARD_MENU.DOCUMENT_CPF';
        }
    }
    changeLanguageEvent() {
        this.changeLanguage.emit();
    }
};
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCUserAccountInfoComponent.prototype, "userProfile", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCUserAccountInfoComponent.prototype, "qrCodeData", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCUserAccountInfoComponent.prototype, "isChangeAccount", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCUserAccountInfoComponent.prototype, "pathFlag", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCUserAccountInfoComponent.prototype, "platform", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCUserAccountInfoComponent.prototype, "changeAccount", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCUserAccountInfoComponent.prototype, "changeLanguage", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCUserAccountInfoComponent.prototype, "copyText", void 0);
UiCUserAccountInfoComponent = __decorate([
    Component({
        selector: 'ui-c-user-account-info',
        template: "<div class=\"ui-c-user-account-info\">\n  <div class=\"qr-code-container\">\n    <qrcode\n      [qrdata]=\"qrCodeValue\"\n      [margin]=\"0\"\n      [errorCorrectionLevel]=\"'M'\"\n      [cssClass]=\"qrCodeData.class\"\n      [colorDark]=\"qrCodeData.colorDark\"\n      [colorLight]=\"qrCodeData.colorLight\"\n      [width]=\"qrCodeData.width\"\n    ></qrcode>\n  </div>\n  <div class=\"account-info-outer\">\n    <div class=\"account-info-container\">\n      <p class=\"font-weight-bold box-left-text\">{{ userProfile?.fullName }}</p>\n      <p class=\"box-left-text\" *ngIf=\"userProfile?.document\">\n        {{ verifyTypeDocument(userProfile?.document) | wlpTranslate }}: {{ userProfile?.document }}\n      </p>\n      <p class=\"box-left-text\">\n        {{ 'CASH_IN.DASHBOARD_MENU.BANK' | wlpTranslate }}: {{ userProfile?.codeBank }} - {{ userProfile?.nameBank }}\n      </p>\n      <p class=\"box-left-text\">\n        {{ 'CASH_IN.DASHBOARD_MENU.AGENCY' | wlpTranslate }}: {{ userProfile?.agencyBank }} |\n        {{ setDigitAccountBank(userProfile?.numberAccountBank) }}\n      </p>\n    </div>\n    <div class=\"copy-button button-box\" (click)=\"copyAccountData()\" id=\"cpyBtn\">\n      <ion-icon class=\"center-content icon-copy icon-size\" name=\"copy-outline\"></ion-icon>\n      <p class=\"text-center font-weight-bold\">{{ 'CASH_IN.DASHBOARD_MENU.COPY' | wlpTranslate }}</p>\n    </div>\n  </div>\n  <ion-row *ngIf=\"isChangeAccount && platform === 'web'\">\n    <ion-col size=\"12\" class=\"change-account\" (click)=\"changeAccountEvent()\">\n      <div>\n        <ion-icon class=\"icon\" name=\"repeat-outline\"></ion-icon>\n        <p>{{ 'CASH_IN.DASHBOARD_MENU.CHANGE_ACCOUNT' | wlpTranslate }}</p>\n      </div>\n    </ion-col>\n  </ion-row>\n  <ion-row *ngIf=\"platform === 'app'\" class=\"flex-row justify-content-around change-account\">\n    <div (click)=\"changeAccountEvent()\" class=\"change-account-icon col-5\">\n      <ion-icon class=\"icon\" name=\"repeat-outline\"></ion-icon>\n      <p>{{ 'CASH_IN.DASHBOARD_MENU.CHANGE_ACCOUNT' | wlpTranslate }}</p>\n    </div>\n    <div (click)=\"changeLanguageEvent()\" class=\"change-account-flag col-5\">\n      <img [src]=\"pathFlag\" alt=\"\" />\n      {{ 'CASH_IN.DASHBOARD_MENU.CHANGE_LANGUAGE' | wlpTranslate }}\n    </div>\n  </ion-row>\n</div>\n"
    }),
    __metadata("design:paramtypes", [ToastController, Clipboard])
], UiCUserAccountInfoComponent);

let UiCUserAccountInfoModule = class UiCUserAccountInfoModule {
};
UiCUserAccountInfoModule = __decorate([
    NgModule({
        declarations: [
            UiCUserAccountInfoComponent
        ],
        imports: [
            ReactiveFormsModule,
            CommonModule,
            IonicModule,
            QRCodeModule,
            UiBsTranslateModule
        ],
        providers: [
            Clipboard
        ],
        exports: [
            UiCUserAccountInfoComponent
        ]
    })
], UiCUserAccountInfoModule);

export { UiCUserAccountInfoComponent, UiCUserAccountInfoModule };
//# sourceMappingURL=wlp-ui-c-user-account-info.js.map
